import anime from "animejs";
import axios from "axios";
import React, { useEffect, useState } from "react";
import LineChart from "../Graph/Graph";
import { useSidebarContext } from "../Sidebar/context/SidebarState";
import styles from "./Dashboard.module.css"; // Import the CSS Module

const ApproverDashboard = ({
  // setShowDashboard,
  showDrafts = false,
  setCurStatus = null,
  userId,
  setFilter,
}) => {
  const {
    isMoreSidebar,
    userName,

    setShowDashboard,
    showDashboard,
    sidebarText,
  } = useSidebarContext();
  //   console.lof(setShowDashboard,"")
  const [boxes, setBoxes] = useState([]);
  console.log(boxes, "boxes");

  const [graphData, setGraphData] = useState([]);
  const [graphData2, setGraphData2] = useState([]);

  const [overAllAmount, setOverAllAmount] = useState([]);
  const [overAllAmount2, setOverAllAmount2] = useState([]);

  const baseUrl = process.env.REACT_APP_SERVER_BASE_URL;

  useEffect(() => {
    boxes.forEach((box) => {
      if (box.statusId === 1 && !showDrafts) return;

      anime({
        targets: `#amount-${box.boxId}`, // Target specific box by ID
        innerHTML: [0, box.totalAmount], // Animate to totalAmount
        easing: "linear",
        round: 1, // Round to nearest integer
        duration: 3000,
      });
    });

    boxes.forEach((box) => {
      if(box.boxId == 17 || box.boxId == 18 || box.boxId == 19){
        anime({
          targets: `#boxID-${box.title}`, // Target specific box by ID
          innerHTML: [0, box.totalAmount], // Animate to totalAmount
          easing: "linear",
          round: 1, // Round to nearest integer
          duration: 3000,
        })
      }
    })
  }, [boxes]);

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    document.documentElement.scrollTop = 0;

    setFilter("");
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/get-dashboarddetailschecker`
        );
        setBoxes(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [baseUrl]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/get-graphdatachecker?userId=${userId}`
        );
        setGraphData(response.data.response1.rows);
        setOverAllAmount(response.data.response1.overallTotalAmount);
        setGraphData2(response.data.response2.rows);
        setOverAllAmount2(response.data.response2.overallTotalAmount);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [baseUrl]);

  const handleClick = (box) => {
    if (box.boxId == 23) {
      setCurStatus("Exceeding 2 days");
    } else if (box.boxId == 1) {
      setCurStatus("");
    } else {
      setCurStatus(box.statusName);
    }
    setShowDashboard(false);
  };

  function formatAmount(amount) {
    if (amount) {
      // Remove commas and convert to number
      const numericAmount = parseFloat(amount.replace(/,/g, ""));

      // Convert amount to lakhs and format accordingly
      const lakhs = numericAmount / 100000;

      // Format lakhs with appropriate decimals and return as string
      return `${lakhs.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
      })} lakhs`;
    }
    return "0"; // Default value if amount is not available
  }

  // Calculate the Distributor box data
  const distributorBox = {
    boxId: 1,
    title: "Distributor",
    totalAmountTitle: boxes.find((box) => box.boxId == 17)?.title || "",
    PendingAmountTitle: boxes.find((box) => box.boxId == 18)?.title || "",
    DisputedAmountTitle: boxes.find((box) => box.boxId == 19)?.title || "",

    totalAmount: boxes.find((box) => box.boxId == 17)?.totalAmount || "0",
    pendingAmount: boxes.find((box) => box.boxId == 18)?.totalAmount || "0",
    disputedAmount: boxes.find((box) => box.boxId == 19)?.totalAmount || "0",
  };

  console.log(distributorBox, 'dis');
  

  return (
    <>
      <div className={styles.dashboardContainer}>
        

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="cust-shadow border p-4 rounded-md bg-card cursor-pointer tab-container" >
            <div
              className="inner"
              style={{ overflowX: "auto", whiteSpace: "nowrap" }}
            >
              <div className="flex justify-evenly items-center gap-2">
                {boxes.map((box) => {
                  if (box.boxId == 17 || box.boxId == 18 || box.boxId == 19) {
                    return (
                      <div className="border p-1 rounded-md border-[#D2C0DA]" key={box.boxId}  onClick={() => handleClick(box)}>
                      <p className="font-bold text-md clr-66615b leading-10 text-sm w-48">
                        {box.title}
                      </p>
                      <div className="text-dark font-extrabold text-xl text-end mt-2">
                        ₹ <span id={`boxID-${box.title}`}>{box.totalAmount}</span>
                      </div>
                    </div>
                    )
                  }
                })}

                
                
              </div>
            </div>
          </div>
          {boxes.map((box) => {
            if (
              (box.boxId == 17 || box.boxId == 18 || box.boxId == 19) &&
              !showDrafts
            ) {
              return null;
            }
            return (
              <div className="cust-shadow border p-4 rounded-md bg-card cursor-pointer flex flex-col justify-between tab-container" onClick={() => handleClick(box)} >
                <p
                  className="font-bold text-md clr-66615b text-sm"
                  dangerouslySetInnerHTML={{
                    __html: box.title.replace(/,/g, "<br/>"),
                  }}
                ></p>
                <div className="text-dark font-extrabold text-xl text-end mt-2">
                  ₹ <span id={`amount-${box.boxId}`}>0</span>
                </div>
              </div>
            );
          })}
        </div>

        <div className={styles.graphContainer}>
          <div className="cust-shadow border p-4 rounded-md bg-card">
            {graphData.length > 0 && <p>{overAllAmount}Lakhs</p>}
            <LineChart graphData={graphData} />
          </div>

          <div className="cust-shadow border p-4 rounded-md bg-card">
            {graphData2.length > 0 && <p>{overAllAmount2}Lakhs</p>}
            <LineChart graphData={graphData2} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ApproverDashboard;
